import { PageEvent } from '@angular/material/paginator';

/**
 * class of constant variables, which are used in various components
 */
export class Constants {
    /** localization texts */
    public static loadingText = $localize`:@@table-data-loading:Loading...`;
    public static noDataText = $localize`:@@table-data-nodata:No data available`;

    /** CRUD column header */
    public static actionColumn = $localize`:@@table-header-action:Action`;

    /**
     * list of currently supported languages
     * @returns [] array of language codes
     */
    public static supportedLanguages: string[] = ['de-DE', 'de-CH', 'en-US', 'es-MX', 'fr-FR', 'nl-NL', 'zh-Hans'];

    /**
     * list of currentlxy supported locales
     * use to format dates and numbers
     * @returns [] array of supprted format locales in scope
     */
    public static supportedLocales: string[] = [
        'de-DE',
        'de-AT',
        'de-CH',
        'en-US',
        'en-GB',
        'es-MX',
        'fr-FR',
        'nl-NL',
        'zh-Hans'
    ];

    /**
     *  defines ranges of items per page in dataTable paginator
     */
    public static pageSizeOptions: number[] = [5, 10, 25, 50, 100];

    /**
     *  default dataTable settings
     *
     *  - length: default length of data
     *  - pageIndex: default page index
     *  - pageSize: default number of items shown on one page
     * @returns  object with settings
     */
    public static pageSettings(): PageEvent {
        return {
            length: 0,
            pageIndex: 0,
            pageSize: 10
        };
    }

    public static services = [
        { id: 'airfreight', icon: 'flight', text: $localize`:@@button-label-airfreight:Airfreight` },
        { id: 'seafreight', icon: 'directions_boat', text: $localize`:@@button-label-seafreight:Seafreight` },
        { id: 'customs', icon: 'account_balance', text: $localize`:@@button-label-customs:Customs` },
        { id: 'express', icon: 'schedule', text: $localize`:@@button-label-express:Express` },
        { id: 'export', icon: 'logout', text: $localize`:@@button-label-export:Export` },
        { id: 'import', icon: 'login', text: $localize`:@@button-label-import:Import` }
    ];

    public static sortbyname = [
        { id: 'asc', text: $localize`:@@select-option-sortbyname-asc:Name A-Z` },
        { id: 'desc', text: $localize`:@@select-option-sortbyname-desc:Name Z-A` }
    ];

    public static companytypes = [
        { id: 'self', text: $localize`:@@select-option-companytype-self:Self-employed` },
        { id: 'private', text: $localize`:@@select-option-companytype-privately:Private company` },
        { id: 'partnership', text: $localize`:@@select-option-companytype-partnership:Partnership` },
        { id: 'corporation', text: $localize`:@@select-option-companytype-corporation:Corporation` }
    ];

    public static companysizes = [
        { id: '0-10', text: $localize`:@@select-option-companysize-micro:Microenterprise (0-10 employees)` },
        { id: '10-49', text: $localize`:@@select-option-companysize-privately:Small business (10-49 employees)` },
        { id: '50-250', text: $localize`:@@select-option-companysize-small:Medium-sized company (50-250 employees)` },
        { id: '250+', text: $localize`:@@select-option-companysize-large:Large corporation (250+ employees)` }
    ];

    public static communityData = [
        {
            title: $localize`:@@scope-community-title-1:Scope Community 1`,
            address: {
                street: 'Frachtgebäude Modul G',
                zip: '85356',
                city: $localize`:@@scope-community-city-munich:Munich Airport`,
                country: $localize`:@@scope-community-country-germany:Germany`
            },
            services: Constants.services.filter((s) => ['airfreight', 'seafreight'].includes(s.id))
        },
        {
            title: $localize`:@@scope-community-title-2:Scope Community 2`,
            address: {
                street: 'Example Street 10',
                zip: '10115',
                city: $localize`:@@scope-community-city-berlin:Berlin`,
                country: $localize`:@@scope-community-country-germany:Germany`
            },
            services: Constants.services.filter((s) => ['import', 'export', 'customs'].includes(s.id))
        },
        {
            title: $localize`:@@scope-community-title-3:Scope Community 3 with LINK`,
            address: {
                street: 'Frachtgebäude Modul G',
                zip: '85356',
                city: $localize`:@@scope-community-city-munich:Munich Airport`,
                country: $localize`:@@scope-community-country-germany:Germany`
            },
            services: Constants.services.filter((s) => ['airfreight', 'seafreight'].includes(s.id)),
            link: 'https://example.com/community1'
        },
        {
            title: $localize`:@@scope-community-title-4:Scope Community 4`,
            address: {
                street: 'Example Street 10',
                zip: '10115',
                city: $localize`:@@scope-community-city-berlin:Berlin`,
                country: $localize`:@@scope-community-country-germany:Germany`
            },
            services: Constants.services.filter((s) => ['import', 'export', 'customs'].includes(s.id))
        },
        {
            title: $localize`:@@scope-community-title-5:Scope Community 5`,
            address: {
                street: 'Example Street 10',
                zip: '10115',
                city: $localize`:@@scope-community-city-cologne:Cologne`,
                country: $localize`:@@scope-community-country-germany:Germany`
            },
            services: Constants.services.filter((s) => ['import', 'export', 'customs'].includes(s.id))
        },
        {
            title: $localize`:@@scope-community-title-6:Scope Community 6`,
            address: {
                street: 'Example Street 10',
                zip: '10115',
                city: $localize`:@@scope-community-city-mannheim:mannheim`,
                country: $localize`:@@scope-community-country-germany:Germany`
            },
            services: Constants.services.filter((s) => ['import', 'export', 'customs'].includes(s.id))
        }
    ];
}
